import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton, IonIcon } from '@ionic/react';
import './PaymentsNone.css';

type PaymentsNoneProps = {
  click: () => void;
};

export default function PaymentsNone({ click }: PaymentsNoneProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <p className="ion-text-center">
        <IonIcon
          className="payment-icon-none"
          src={'assets/icon/card-big.svg'}
        ></IonIcon>
      </p>

      <h1 className="h1 h1plus pt-2 ion-text-center">
        {t('payments.nonetitle')}
      </h1>
      <div className="payment-methods">
        <p className="pt-2 pb-3 instructions ion-text-center">
          {t('payments.addinfo')}
        </p>
      </div>

      <div className="pt-1 ion-text-center">
        <IonButton className="btn-default btn-wide-80" onClick={() => click()}>
          <IonIcon slot="start" src={'assets/icon/card.svg'}></IonIcon>
          {t('payments.add')}
        </IonButton>
      </div>

      <div className="payment-methods">
        <IonIcon slot="start" src={'assets/icon/master_card.svg'}></IonIcon>
        <IonIcon slot="start" src={'assets/icon/visa.svg'}></IonIcon>
        <IonIcon slot="start" src={'assets/icon/american_express.svg'}></IonIcon>
        <IonIcon slot="start" src={'assets/icon/discover.svg'}></IonIcon>
      </div>
    </>
  );
}
